@if (pages() > 0) {
    <div class="cerrix-pagination-ghost-container">
        <div></div>
        @for (i of ghostSlots(); track $index) {
            <div></div>
        }
        <div></div>
    </div>
    <div class="cerrix-pagination-container">
        <button
            type="button"
            class="page-arrow"
            (click)="updatePage(currentPage() - 1)"
            [disabled]="currentPage() === 1"
            [attr.aria-label]="'previous' | t"
        ><mat-icon svgIcon="arrow-left" /></button>
        <div class="page-number-container">
            @for (v of pagination(); track $index) {
                @if (v === -1) {
                    <span class="page-ellipsis">…</span>
                } @else {
                    <button
                        type="button"
                        class="page-number"
                        [class.active]="v === currentPage()"
                        [attr.aria-current]="v === currentPage() ? 'page' : null"
                        [attr.aria-label]="'page' | t: { page: v }"
                        (click)="updatePage(v)"
                    >
                        {{ v }}
                    </button>
                }
            }
        </div>

        <button
            type="button"
            class="page-arrow"
            (click)="updatePage(currentPage() + 1)"
            [disabled]="currentPage() === pages()"
            [attr.aria-label]="'next' | t"
        ><mat-icon svgIcon="arrow-right" /></button>
    </div>
}
